import styled from 'styled-components';
import { Field } from '@m/alchemy-ui/Field';
import { units } from '@m/alchemy-ui/theme';

export const RewardPickerContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  margin-bottom: ${units(3)};
  max-width: 600px;
`;

export const RewardPickerOptionContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 200px;
`;

export const RewardIconsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const DialogField = styled(Field)`
  margin-top: ${units(2)};
`;

export const ClearedDate = styled.p`
  padding: ${units(1)};
`;
